import React, { useState, useMemo, useEffect } from 'react';
import { Button, Empty, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import map from 'lodash/map';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from './Box';
import AddLockBox from './AddLock';
import BoxSetting from './BoxSetting';
import { BOXES } from 'api';
import useFetch from 'utils/fetch/useFetch';
import ModalUser from '../../Customers/components/ModalInfo';
import { ReactComponent as Delete } from '../../../images/trash_red.svg';
import { ReactComponent as Pen } from '../../../images/pen.svg';

const BoxAddButton = styled(Button)`
  &&& {
    border: 1px dashed #cacace;
    border-radius: 0px;
    width: 80px;
    height: 80px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0px;
    color: #cacace;
  }
`;

const Wrapper = styled.div`
  &&& {
    button {
      &:active {
      }
    }
    &:hover {
      .deleteSection {
        display: flex;
        &:hover {
          color: #ff3d3d;
          padding: 0;
          height: auto;
          margin-left: 10px;
        }
      }
    }
    .deleteSection {
      display: none;
      padding: 0;
      height: auto;
      margin-left: 10px;
    }
    .ant-input {
      &:focus {
        border: none;
        box-shadow: none;
      }
    }
  }
`;

function Section({
  section,
  boxes,
  update,
  deleteSection,
  locks,
  postBox,
  getSection,
  storageId,
  getDevices,
  getBoxes,
  updateDevice,
  updateBox,
  users,
  loadingDevice,
  getUsers,
  socket,
  updateUsers,
}) {
  const [visible, setVisible] = useState(false);
  const [visibleSetting, setVisibleSetting] = useState(false);
  const [sectionName, setSectionName] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [sectionGroup, setSectionGroup] = useState([]);
  const [userVisible, setUserVisible] = useState(false);
  const [box, setBox] = useState(null);
  const [boxId, setBoxId] = useState(null);
  const [user, setUser] = useState(null);
  const [boxNotLock, setBoxNotLock] = useState(null);
  const [currentValue, setCurrentValue] = useState(0);
  const [newBox, setNewBox] = useState(false);
  const { t } = useTranslation();

  const {
    data: boxesForUsers = [],
    getData: getBoxesForUser,
    loading: boxLoading,
  } = useFetch(BOXES, {
    uniqId: 'boxesForUser',
    autoFetch: false,
  });

  const AddLock = (visible, name, id, box) => {
    setVisible(visible);
    setSectionName(name);
    setSectionId(id);
    if (box === 'new') {
      setNewBox(true);
    } else {
      setBoxNotLock(box);
    }
  };

  const editBox = (box) => {
    setVisibleSetting(!visibleSetting);
    setBox(box);
  };

  const editVisible = (e, name) => {
    const input = e.target.closest('.editWrapper').querySelector('.ant-input');
    const icon = e.target.closest('.editWrapper').querySelector('.penIcon');
    if (e.target.closest('.editWrapper').querySelector('.hidden')) {
      e.target
        .closest('.editWrapper')
        .querySelector('.inputEditSection')
        .classList.remove('hidden');
      input.focus();
      e.target
        .closest('.editWrapper')
        .querySelector('.sectionName')
        .classList.add('hidden');
      icon.classList.add('hidden');
    } else {
      e.target
        .closest('.editWrapper')
        .querySelector('.inputEditSection')
        .classList.add('hidden');
    }
  };

  const editNameSection = (e, id) => {
    const icon = e.target.closest('.editWrapper').querySelector('.penIcon');
    e.target
      .closest('.editWrapper')
      .querySelector('.inputEditSection')
      .classList.add('hidden');
    icon.classList.remove('hidden');
    e.target
      .closest('.editWrapper')
      .querySelector('.sectionName')
      .classList.remove('hidden');
    update(e.target.value, id);
    setCurrentValue(0);
  };

  useMemo(() => {
    const group = [];
    if (section && section.length !== 0 && boxes) {
      each(section, (item) => {
        group.push({ section: item });
      });
      each(group, (item) => {
        const id = item.section.id;
        const boxesArr = [];
        const section = item;
        each(boxes, (item) => {
          if (item.section_id === id) {
            boxesArr.push(item);
            section.boxes = boxesArr;
          }
        });
      });
    }
    if (!isEmpty(group)) {
      const sorted = sortBy(group, (item) => item.section.id);
      setSectionGroup(sorted);
    }
    //обновляем информацию модального окна при изменении данных
    if (box && !isEmpty(group)) {
      const sorted = filter(boxes, (item) => {
        return item.id === box.id;
      });

      setBox(sorted[0]);
    }
    if (!box && boxId && visibleSetting) {
      const sorted = filter(boxes, (item) => {
        return item.id === boxId;
      });

      setBox(sorted[0]);
    }
  }, [boxes, section, visibleSetting, box, boxId]);

  const onChange = (e) => {
    setCurrentValue(e.target.value);
  };

  const handleSection = (id) => {
    deleteSection(
      { id },
      {
        sync: false,

        getSyncData: {
          fetchFunc: getSection,
          params: {
            warehouse_id: storageId,
          },
        },
      },
    );
  };

  useEffect(() => {
    if (user) {
      const newData = filter(users, (item) => {
        return item.id === user.id;
      });
      setUser(newData[0]);
    }
  }, [users, user]);

  return (
    <div>
      {!isEmpty(sectionGroup) ? (
        map(sectionGroup, (item) => {
          return (
            <Wrapper key={item.section.id}>
              <div className="text-black flex items-center text-16 h-40 font-medium">
                {' '}
                <div className="flex items-center editWrapper">
                  <div className="sectionName">{item.section.name} </div>
                  <div className="flex hidden  inputEditSection">
                    <Input
                      onBlur={(e) => {
                        editNameSection(e, item.section.id);
                      }}
                      onChange={onChange}
                      value={
                        currentValue === 0 ? item.section.name : currentValue
                      }
                      className="border-0 p-0 bg-ghost  text-16 font-medium text-black"
                    />
                  </div>
                  <Pen
                    onClick={(e) => {
                      editVisible(e);
                    }}
                    className="penIcon cursor-pointer ml-10"
                  />
                </div>
                <Button
                  className="deleteSection"
                  onClick={() => {
                    handleSection(item.section.id);
                  }}
                  type="ghost text-red border-0 shadow-none flex items-center"
                >
                  <Delete className="mr-10" />
                  {t('deleteSection')}
                </Button>
              </div>
              <div className="flex flex-wrap mt-25 mb-40">
                {map(
                  sortBy(item.boxes, (item) => item.id),
                  (box) => {
                    if (box.device) {
                      return (
                        <div key={box.id}>
                          {box.available ? (
                            //открыт арендатором
                            box.device.telemetry.open &&
                            (box.device.open_close_type === 'button' ||
                              (box.device.open_close_type === 'backend' &&
                                box.device.open_close_user.role === 'client') ||
                              (box.device.open_close_type === 'bluetooth' &&
                                box.device.open_close_user.role ===
                                  'client')) ? (
                              <div
                                onClick={() => {
                                  editBox(box);
                                }}
                              >
                                <Box
                                  expired={box.expired}
                                  name={box.name}
                                  openUser
                                />
                              </div>
                            ) : //открыт админом
                            box.device.telemetry.open &&
                              box.device.open_close_type === 'backend' &&
                              box.device.open_close_user.role === 'admin' ? (
                              <div
                                onClick={() => {
                                  editBox(box);
                                }}
                              >
                                <Box
                                  expired={box.expired}
                                  name={box.name}
                                  openAdmin
                                />
                              </div>
                            ) : box.device.telemetry.open &&
                              !box.device.open_close_type ? (
                              <div
                                onClick={() => {
                                  editBox(box);
                                }}
                              >
                                <Box
                                  expired={box.expired}
                                  name={box.name}
                                  undef
                                />
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  editBox(box);
                                }}
                              >
                                <Box name={box.name} avalibale />
                              </div>
                            )
                          ) : (
                            <div
                              onClick={() => {
                                editBox(box);
                              }}
                            >
                              <Box
                                expired={box.expired}
                                notAvalibale
                                name={box.name}
                              />
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={box.id}
                          onClick={() => {
                            AddLock(
                              !visible,
                              item.section.name,
                              item.section.id,
                              box,
                            );
                          }}
                        >
                          {' '}
                          <Box name={box.name} notAttached />
                        </div>
                      );
                    }
                  },
                )}
                <BoxAddButton
                  type="link"
                  onClick={() => {
                    AddLock(
                      !visible,
                      item.section.name,
                      item.section.id,
                      'new',
                    );
                  }}
                >
                  <PlusOutlined />
                </BoxAddButton>
              </div>
            </Wrapper>
          );
        })
      ) : (
        <Empty />
      )}
      {boxNotLock ? (
        <AddLockBox
          sectionName={sectionName}
          sectionId={sectionId}
          locks={locks}
          visible={visible}
          setVisible={setVisible}
          postBox={postBox}
          getSection={getSection}
          storageId={storageId}
          getBoxes={getBoxes}
          getDevices={getDevices}
          box={boxNotLock}
          boxName={boxNotLock.name}
          updateDevice={updateDevice}
          setBoxNotLock={setBoxNotLock}
          updateBox={updateBox}
          setBoxId={setBoxId}
          setVisibleSetting={setVisibleSetting}
          visibleSetting={visibleSetting}
          loadingDevice={loadingDevice}
        />
      ) : newBox ? (
        <AddLockBox
          source="new"
          sectionName={sectionName}
          sectionId={sectionId}
          locks={locks}
          visible={visible}
          setVisible={setVisible}
          postBox={postBox}
          getSection={getSection}
          storageId={storageId}
          getBoxes={getBoxes}
          getDevices={getDevices}
          setNewBox={setNewBox}
          loadingDevice={loadingDevice}
        />
      ) : null}
      {box ? (
        <BoxSetting
          setUser={setUser}
          data={box}
          visible={visibleSetting}
          setVisible={setVisibleSetting}
          visibleAdd={visible}
          setVisibleAdd={setVisible}
          setBox={setBox}
          updateDevice={updateDevice}
          getBoxes={getBoxes}
          storageId={storageId}
          updateBox={updateBox}
          allUsers={users}
          getAllUsers={getUsers}
          getSection={getSection}
          boxes={boxes}
          socket={socket}
          userVisible={userVisible}
          setUserVisible={setUserVisible}
        />
      ) : null}
      {userVisible && user ? (
        <ModalUser
          source="warehouse"
          setUser={setUser}
          loadingBox={boxLoading}
          boxes={boxesForUsers}
          getBoxes={getBoxesForUser}
          updateData={updateUsers}
          user={user}
          users={users}
          getUsers={getUsers}
          visible={userVisible}
          setVisible={setUserVisible}
          updateDevice={updateDevice}
          updateBox={updateBox}
          locks={locks}
          getDevices={getDevices}
          postBox={postBox}
          setBox={setBox}
          setVisibleAdd={setVisible}
          visibleAdd={visible}
          setVisibleBox={setVisibleSetting}
          visibleBox={visibleSetting}
          setBoxNotLock={setBoxNotLock}
        />
      ) : null}
    </div>
  );
}

Section.propTypes = {};

export default Section;
